export default class {
    /* Configuration */
    // If this api has an option to call items by a key (id)
    isKeyable(keyName = 'id') {
        this.keyable = keyName;
        return this;
    }

    /* GETTERS & SETTERS */
    get Observer() { return this._observer || (this._observer = new App.Entities.Observer(this)) }
    get params() {
        switch (typeof this._params) {
            case "undefined":
                return {};
            case "object":
                return this._params;
            case "function":
                return this._params();
        }
    }
    set params(params) {
        this._params = params;
    }

    setTimestamp() {
        this.timestamp = Date.now();
    }

    setModel(name) {
        this.model = name;
        return this;
    }

    /* INTERFACE: It only set an interface for heritage */
    filter(response) {
        let items = response;
        if (this.model) {
            for (let item in items) items[item] = this.applyModel(items[item]);
        }
        return items;
    }

    applyModel(item, source = 'root') {
        item['source'] = source;
        return this.model ? new App.Model[this.model](item).get : item;
    }

    reset() {
        this._response = false;
        return this;
    }

    /* INTERFACE: It only set an interface for heritage */
    update() {
        this
            .reset()
            .Observer.notify()
        ;
    }
}
